import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { loading } from '@/decorators';
import { enumData } from '@/decorators';

var AddEditModal = function (_super) {
  __extends(AddEditModal, _super);

  function AddEditModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.colSpan = 3;
    _this.formDataRule = {
      warehouse_code: [{
        required: true,
        message: _this.t('请选择入库仓库（区域）')
      }],
      consumable_type: [{
        required: true,
        message: _this.t('请选择耗材类型')
      }],
      detail_list: [{
        required: true,
        type: 'array',
        message: _this.t('请添加耗材信息')
      }]
    };
    _this.loading = false;
    _this.formData = _this.initFormData();
    _this.wrapperList = [];
    _this.detailItem = _this.initDetailItem();
    _this.warehouseList = [];
    _this.consumableTypeEnum = [];
    _this.columns = [];
    return _this;
  }

  AddEditModal.prototype.initDetailItem = function () {
    return {
      consumable_code: '',
      consumable_num: '',
      consumable_name: '',
      board_no: '',
      consumable_type: '',
      consumable_type_text: ''
    };
  };

  AddEditModal.prototype.initFormData = function (data) {
    var originData = {
      order_code: undefined,
      detail_list: [],
      consumable_type: undefined,
      warehouse_code: undefined,
      remark: ''
    };

    if (data) {
      for (var key in originData) {
        if (data.hasOwnProperty(key)) {
          originData[key] = data[key];
        }
      }
    }

    return originData;
  };

  AddEditModal.prototype.setColumns = function () {
    this.columns = [{
      title: this.t('箱数/卡板数'),
      dataIndex: 'board_no',
      filterEmpty: true
    }, {
      title: this.t('耗材编码'),
      dataIndex: 'consumable_code',
      filterEmpty: true
    }, {
      title: this.t('耗材名称'),
      dataIndex: 'consumable_name',
      filterEmpty: true
    }, {
      title: this.t('数量'),
      dataIndex: 'consumable_num',
      filterEmpty: true
    }, {
      width: 150,
      title: this.t('操作'),
      name: 'operation',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
  };

  AddEditModal.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.common.queryAllWarehouseList({
              is_open_only: true
            })];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.warehouseList = data;
            return [2];
        }
      });
    });
  };

  AddEditModal.prototype.queryList = function (packageCode) {
    return __awaiter(this, void 0, Promise, function () {
      var data, list;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.wrapperList = [];
            return [4, this.$api.wrapper.queryConsumableMaterialList({
              audit_status: this.$enum.warehouse.ConsumableMaterialStatus.PASS,
              consumable_type: this.formData.consumable_type,
              consumable_code_like: packageCode
            })];

          case 1:
            data = _a.sent().data;
            list = data.list;
            this.wrapperList = list || [];
            return [2, list || []];
        }
      });
    });
  };

  AddEditModal.prototype.handleAdd = function () {
    var _this = this;

    var res1 = !!this.formData.consumable_type;
    var diffValue = this.detailItem.board_no && this.formData.detail_list.length ? this.detailItem.board_no - this.formData.detail_list[this.formData.detail_list.length - 1].board_no : 0;
    var startFormOne = Number(this.detailItem.board_no) === 1;

    if (this.formData.detail_list.length && diffValue !== 1 && diffValue !== 0 || !this.formData.detail_list.length && !startFormOne) {
      this.$message.warning(this.t('箱数/卡板数必须为从1开始的连续正整数,请重新输入'));
      return;
    }

    if (!this.detailItem.board_no) {
      this.$message.warn(this.t('请先输入箱数/卡板数'));
      return;
    }

    var reg = /^[1-9]\d{0,8}$/gi;

    if (!reg.test(String(this.detailItem.board_no))) {
      this.$message.warn(this.t('箱数/卡板数请输入1-99999999的整数'));
      return;
    }

    if (!this.detailItem.consumable_name) {
      this.$message.warn(this.t('请先选择耗材信息'));
      return;
    }

    if (!res1) {
      this.$message.warning(this.t('请选择耗材类型'));
      return;
    }

    if (this.detailItem.consumable_num >= 100000000 || this.detailItem.consumable_num < 1) {
      this.$message.warning(this.t('请输入正确的数值，限制为1-99999999'));
      return;
    }

    var res = this.formData.detail_list.find(function (item) {
      return item.consumable_code + item.board_no === _this.detailItem.consumable_code + _this.detailItem.board_no;
    });

    if (res) {
      this.$message.warning(this.t('该箱数/卡板数+耗材编码已存在'));
      return;
    }

    this.formData.detail_list.push(this.$util.deepCopy(this.detailItem));
    this.detailItem = this.initDetailItem();
  };

  AddEditModal.prototype.handleConsumableTypeChange = function (value) {
    this.formData.detail_list = [];
  };

  AddEditModal.prototype.handleSelectPackage = function () {
    var item = this.$util.findItemByKeyValue(this.wrapperList, this.detailItem.consumable_code, 'consumable_code');

    if (item) {
      this.detailItem = {
        consumable_code: item.consumable_code,
        consumable_name: item.consumable_name,
        consumable_num: this.detailItem.consumable_num,
        board_no: this.detailItem.board_no,
        consumable_type: item.consumable_type
      };
    } else {
      this.$message.warn(this.t('数据异常，请重新选择'));
    }
  };

  AddEditModal.prototype.beforeSearchFun = function () {
    this.wrapperList = [];

    if (!this.formData.consumable_type) {
      this.$message.warn(this.t('请选择耗材类型'));
      return false;
    }
  };

  AddEditModal.prototype.handleSearchPackageList = function (value) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.queryList(value)];

          case 1:
            return [2, _a.sent()];
        }
      });
    });
  };

  AddEditModal.prototype.handleDelete = function (index) {
    this.formData.detail_list.splice(index, 1);
  };

  AddEditModal.prototype.addWrapperInbound = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.wrapper.saveConsumableMaterialInbound(param)];

          case 1:
            _a.sent();

            this.$message.success(this.t('操作成功'));
            return [2];
        }
      });
    });
  };

  AddEditModal.prototype.editWrapperInbound = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.wrapper.saveConsumableMaterialInbound(param)];

          case 1:
            _a.sent();

            this.$message.success(this.t('保存成功'));
            return [2];
        }
      });
    });
  };

  AddEditModal.prototype.handleSave = function () {
    return __awaiter(this, void 0, Promise, function () {
      var formDataRef, res, postData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            formDataRef = this.$refs.formDataRef;
            return [4, formDataRef.validate()];

          case 1:
            res = _a.sent();

            if (!res) {
              return [2];
            }

            if (!this.validSeriality()) {
              this.$message.warning(this.t('箱数/卡板数必须为从1开始的连续正整数,请重新输入'));
              return [2];
            }

            postData = this.$util.deepCopy(this.formData);
            postData.detail_list.sort(function (item1, item2) {
              return Number(item1.board_no) - Number(item2.board_no);
            });
            if (!this.formData.order_code) return [3, 3];
            return [4, this.editWrapperInbound(postData)];

          case 2:
            _a.sent();

            return [3, 5];

          case 3:
            return [4, this.addWrapperInbound(postData)];

          case 4:
            _a.sent();

            _a.label = 5;

          case 5:
            this.$emit('success');
            this.$emit('update:visible', false);
            return [2];
        }
      });
    });
  };

  AddEditModal.prototype.validSeriality = function () {
    var boardNos = this.formData.detail_list.map(function (item) {
      return item.board_no;
    });
    var uniList = Array.from(new Set(boardNos));

    if (Math.max.apply(Math, uniList) === uniList.length) {
      return true;
    }

    return false;
  };

  AddEditModal.prototype.handlePackageBlur = function () {
    var item = this.$util.findItemByKeyValue(this.wrapperList, this.detailItem.consumable_code, 'consumable_code');

    if (!item) {
      this.detailItem.consumable_code = '';
      this.detailItem.consumable_name = '';
    }

    this.wrapperList = [];
  };

  AddEditModal.prototype.handleClose = function () {
    this.$emit('update:visible', false);
  };

  AddEditModal.prototype.created = function () {
    this.setColumns();
  };

  AddEditModal.prototype.handleVisibleChange = function () {
    if (this.visible) {
      this.formData = this.initFormData(this.$util.deepCopy(this.rowData.data));
      this.queryWarehouseList();
    } else {
      var formDataRef = this.$refs.formDataRef;
      this.detailItem = this.initDetailItem();
      this.wrapperList = [];
      formDataRef && formDataRef.clearValidate();
    }
  };

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], AddEditModal.prototype, "visible", void 0);

  __decorate([Prop({})], AddEditModal.prototype, "rowData", void 0);

  __decorate([enumData('ConsumableTypeEnableEnum')], AddEditModal.prototype, "consumableTypeEnum", void 0);

  __decorate([loading('loadingStatus')], AddEditModal.prototype, "queryList", null);

  __decorate([loading('loading')], AddEditModal.prototype, "addWrapperInbound", null);

  __decorate([loading('loading')], AddEditModal.prototype, "editWrapperInbound", null);

  __decorate([Watch('visible', {
    deep: true,
    immediate: true
  })], AddEditModal.prototype, "handleVisibleChange", null);

  AddEditModal = __decorate([Component], AddEditModal);
  return AddEditModal;
}(Vue);

export default AddEditModal;